<template>
  <div class="company-detail">
    <el-card class="card">
      <div class="header">
        <img class="logo" :src="photo(company.companyLogo)" alt="logo" />
        <div class="meta">
          <h2>{{ company.companyName || '-' }}</h2>
          <div class="row">
            <el-tag effect="plain">{{ company.companyIndustry || '未知行业' }}</el-tag>
            <el-tag effect="plain">{{ company.staffNumber || '规模未知' }}</el-tag>
            <!-- <el-tag type="info" effect="plain">联系人：{{ company.director || '-' }}</el-tag> -->
          </div>
        </div>
      </div>
      <el-divider />
      <el-descriptions :column="1" border>
        <el-descriptions-item label="企业地址">{{ company.companyAddress || '-' }}</el-descriptions-item>
        <el-descriptions-item label="企业简介">{{ company.introduction || '暂无' }}</el-descriptions-item>
        <el-descriptions-item label="更多信息">{{ company.contents || '暂无' }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="card">
      <h3>热招职位</h3>
      <el-empty v-if="hotJobs.length===0" description="暂无" />
      <div v-else class="hot-jobs">
        <div class="job" v-for="j in visibleJobs" :key="j._id" @click="goJob(j)">
          <div class="jn">{{ j.jobName }}</div>
          <div class="sal">{{ j.salary }}</div>
          <div class="meta">{{ j.address }} · {{ j.type }}</div>
        </div>
      </div>
      <div v-if="hotJobs.length > showCount" style="margin-top:8px;text-align:center;">
        <el-button size="small" type="primary" @click="loadMore">查阅更多岗位</el-button>
      </div>
    </el-card>

    <el-card class="card">
      <h3>公司相册</h3>
      <el-empty v-if="albumUrls.length===0" description="暂无" />
      <el-carousel v-else height="360px" indicator-position="outside">
        <el-carousel-item v-for="(u,idx) in albumUrls" :key="idx">
          <img :src="u" style="width:100%;height:360px;object-fit:cover;border-radius:8px" />
        </el-carousel-item>
      </el-carousel>
    </el-card>

    <el-card class="card">
      <h3>企业文化</h3>
      <div>{{ company.culture || '暂无' }}</div>
      <h3 style="margin-top:12px">发展历程</h3>
      <div>{{ company.history || '暂无' }}</div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from '@/util/axios.config'

const route = useRoute()
const router = useRouter()
const company = ref({})
const hotJobs = ref([])
const showCount = ref(8)
const visibleJobs = computed(()=> hotJobs.value.slice(0, showCount.value))

const photo = (url) => {
  if (!url) return 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
  // 如果是完整URL，直接返回；否则使用相对路径通过代理
  return /^(http|https):/i.test(url) ? url : url
}
const albumUrls = computed(()=> Array.isArray(company.value.album) ? company.value.album.map(photo) : [])

onMounted(async()=>{
  const director = route.query.director
  const inline = route.query.company
  if (inline) {
    try { company.value = JSON.parse(inline) } catch(e) {}
  }
  if (director) {
    try{
      const { data } = await axios.get(`/companyapi/user/getMessage/${director}`)
      company.value = (data.Message && data.Message[0]) || company.value
      // 热招职位：优先从公司接口拉取，若为空则从 staff 列表中过滤
      let list = []
      try{
        // 优先使用专门的 staff 接口，确保代理设置生效
        const r0 = await axios.get(`/staffapi/jobs/byCompany`, { params: { pubUser: director, companyName: company.value?.companyName } })
        list = r0.data?.jobsList || []
      }catch(_){}
      if (!Array.isArray(list) || list.length === 0) {
        try{
          const r1 = await axios.get(`/companyapi/jobs/list/${director}`)
          list = r1.data?.jobsList || []
        }catch(_){}
      }
      if (!Array.isArray(list) || list.length === 0) {
        const r2 = await axios.get('/staffapi/jobs/list')
        const allJobs = r2.data?.jobsList || []
        const dl = String(director || '').toLowerCase()
        list = allJobs.filter(j => {
          const byUser = (j.pubUser || '').toLowerCase() === dl
          const byDirector = (j.companyMessage?.director || '').toLowerCase() === dl
          const byName = company.value?.companyName && (j.companyMessage?.companyName === company.value.companyName)
          return byUser || byDirector || byName
        })
      }
      hotJobs.value = list
    }catch(e){ console.log(e) }
  }
})

function loadMore(){
  // 每次增加一行（4条），最多两行（8条）再继续 +4
  showCount.value = Math.min(showCount.value + 4, hotJobs.value.length)
}

function goJob(job){
  try{
    router.push({ path: '/detail', query: { job: JSON.stringify(job) } })
  }catch(e){
    console.log(e)
  }
}
</script>

<style scoped>
.company-detail{ width: 1200px; margin: 20px auto; }
.card{ border-radius: 12px; margin-bottom: 16px; }
.header{ display:flex; align-items:center; gap:16px; }
.logo{ width: 88px; height: 88px; border-radius: 12px; object-fit: cover; border:1px solid #eee; }
.row{ display:flex; gap:8px; margin-top:6px; }
.hot-jobs{ display:grid; grid-template-columns:repeat(4, 1fr); gap:12px; }
.job{ background:#f8fafc; border:1px solid #eef2f7; border-radius:10px; padding:10px; box-sizing:border-box; }
.job .jn{ font-weight:600; }
.job .sal{ color:#409eff; margin-top:4px; }
.job .meta{ color:#9aa0a6; font-size:12px; margin-top:4px; }
</style>


